import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {Table} from '../../../components/table/table.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';

interface OwnProps {
    occasion: OccasionType;
}
export function History({occasion}: OwnProps) {
    return (
        <div className={styles.tabs_grid}>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.maintenance_booklets')}
                        value={occasion.maintenance_booklets ? __('general.yes') : __('general.no')}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.dealer_maintained')}
                        value={occasion.dealer_maintained ? __('general.yes') : __('general.no')}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.first_owner')}
                        value={occasion.first_owner ? __('general.yes') : __('general.no')}
                    />
                </TableRow>
            </Table>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                {occasion.number_of_owners != 0 && (
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.number_of_owners')}
                            value={occasion.number_of_owners}
                        />
                    </TableRow>
                )}
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.date_first_issue')}
                        value={occasion.date_first_issue}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.date_first_admission')}
                        value={occasion.date_first_admission}
                    />
                </TableRow>
            </Table>
        </div>
    );
}
